import { defineMessages } from 'react-intl';

export const messages: {
	itemsLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	preamble: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	preambleSupportLinkLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	preambleWithoutSupportLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	stylesLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	title: {
		id: 'company-hub.links-menu-extension.config-panel.title',
		defaultMessage: 'Links menu',
		description: 'A visible text label to be used as the title for the links menu config panel',
	},
	preamble: {
		id: 'company-hub.links-menu-extension.config-panel.preamble',
		defaultMessage: 'Add links and organize them with submenus. {linksMenuSupportLink}',
		description: 'A visible text label to be used as the preamble for the links menu config panel',
	},
	preambleWithoutSupportLink: {
		id: 'company-hub.links-menu-extension.config-panel.preamble-without-support-link',
		defaultMessage: 'Add links and organize them with submenus.',
		description:
			'A visible text label to be used as the preamble for the links menu config panel without a support link',
	},
	preambleSupportLinkLabel: {
		id: 'company-hub.links-menu-extension.config-panel.preamble-link.label',
		defaultMessage: 'Learn more about links menu',
		description:
			'A visible text label to be used as a link to a support page in the preamble of the Links menu config panel',
	},
	itemsLabel: {
		id: 'company-hub.links-menu-extension.config-panel.items.label',
		defaultMessage: 'Items',
		description: 'Variant for Items in Links Menu extension',
	},
	stylesLabel: {
		id: 'company-hub.links-menu-extension.config-panel.styles.label',
		defaultMessage: 'Styles',
		description: 'Variant for Styles in Links Menu extension',
	},
});
